import { OpportunityItemStatus, OpportunityMember } from '@/models/opportunities';
import { router } from '@/main';

export function isOpportunityInactive(status: OpportunityItemStatus): boolean {
  return [
    OpportunityItemStatus.Finalized,
    OpportunityItemStatus.Deleted,
    OpportunityItemStatus.Rejected,
    OpportunityItemStatus.Canceled,
  ].includes(status);
}

export function getGeekDetails(geek: OpportunityMember) {
  if (!geek.geekJobInfo) {
    return '';
  }

  const geekJobInfo = `
    <div>${router.app.$t('geek-job-info.department')}: ${geek.geekJobInfo.department}</div>
    <div>${router.app.$t('geek-job-info.location')}: ${geek.geekJobInfo.location}</div>
    <div>${router.app.$t('geek-job-info.designation')}: ${geek.geekJobInfo.designation}</div>
    <div>${router.app.$t('geek-job-info.practice')}: ${geek.geekJobInfo.practice}</div>
  `;

  if (!geek.additionalInfo) {
    return geekJobInfo;
  }

  return geekJobInfo + `
    </br>
    <div>${router.app.$t('geek-job-info.additional-info')}: ${geek.additionalInfo}</div>
  `;
}
